import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getgenderdistribution } from "../../../services/DashboardService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateReportAction } from "../../../store/actions/AuthActions";
import { Spinner } from "react-bootstrap";
const GenderDistributionChart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useState({
    time_period: "week",
  });
  useEffect(() => {
    setLoading(true);
    getgenderdistribution(param)
      .then((res) => {
        setData(res?.data?.data || null);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  const chartOptions = {
    chart: {
      type: "pie",
      toolbar: { show: false },
    },
    responsive: [
      {
        breakpoint: 1000, // At smaller screen sizes
        options: {
          chart: {
            height: 180, // Smaller height for mobile view
          },
        },
      },
    ],
    labels: ["Male", "Female"],
    legend: {
      position: "bottom",
      labels: {
        // colors: ["#ffffff"],
        useSeriesColors: false,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      theme: "dark",
    },
    colors: ["#482807", "#e7c68e"], // Blue shades
  };
  const chartSeries = [data?.male?.count || 0, data?.female?.count || 0]; // Example static data
  const handlegenderreport = () => {
    dispatch(
      updateReportAction({
        label: "Gender Distribution Report",
        value: "GenderDistributionreport",
      })
    );
    navigate("/report");
  };
  return (
    <>
      <div className="card border rounded-3">
        <div className="p-2 d-flex justify-content-between">
          <span className="text-primary" style={{ fontWeight: "500" }}>
            {" "}
            Pass holder Gender distribution
          </span>
          <span className="btn-group align-self-start">
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "week" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "week" })}
            >
              W
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "month" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "month" })}
            >
              M
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "year" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "year" })}
            >
              Y
            </button>
          </span>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="text-center my-3">
              <Spinner animation="border" size="sm" />
            </div>
          ) : !data ? (
            <div className="text-center my-2">No Data Found</div>
          ) : (
            <div className="row d-flex align-items-center text-white">
              {/* Left: Chart */}
              <div className="col-12 col-md-7">
                <ReactApexChart
                  key={
                    chartSeries.join(",") +
                    (chartOptions?.labels?.join(",") || "")
                  }
                  options={chartOptions}
                  series={chartSeries}
                  type="pie"
                  height={240}
                />
              </div>
              <div className="col-12 col-md-5">
                <div className="d-flex flex-row flex-sm-column align-items-start justify-content-center gap-3 ps-sm-3 mt-3 mt-sm-0">
                  <div className="d-flex align-items-sm-center gap-1">
                    <strong className="text-primary">Male:</strong>
                    <span className="text-primary">
                      {data?.male?.percentage}%
                    </span>
                  </div>
                  <div className="d-flex align-items-sm-center gap-1">
                    <strong className="text-primary">Female:</strong>
                    <span className="text-primary">
                      {data?.female?.percentage}%
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="text-center pt-1"
                style={{ fontWeight: "500", fontSize: "0.9rem" }}
              >
                <span
                  className="text-primary cursor-pointer"
                  onClick={handlegenderreport}
                >
                  View Reports
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GenderDistributionChart;
